import { Routes } from '@angular/router';

import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((mod) => mod.LoginComponent),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./dashboard/dashboard.component').then(
        (mod) => mod.DashboardComponent
      ),
  },
  {
    path: 'user-list',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./user/user-list/user-list.component').then(
        (mod) => mod.UserListComponent
      ),
  },
  {
    path: 'create-user',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./user/create-user/create-user.component').then(
        (mod) => mod.CreateUserComponent
      ),
  },
  {
    path: 'user-details/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./user/user-details/user-details.component').then(
        (mod) => mod.UserDetailsComponent
      ),
  },
  {
    path: 'change-password',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./user/change-password/change-password.component').then(
        (mod) => mod.ChangePasswordComponent
      ),
  },
  {
    path: 'create-beneficiary',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './beneficiary/create-beneficiary/create-beneficiary.component'
      ).then((mod) => mod.CreateBeneficiaryComponent),
  },
  {
    path: 'beneficiary-list',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./beneficiary/beneficiary-list/beneficiary-list.component').then(
        (mod) => mod.BeneficiaryListComponent
      ),
  },
  {
    path: 'beneficiary-details/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './beneficiary/beneficiary-details/beneficiary-details.component'
      ).then((mod) => mod.BeneficiaryDetailsComponent),
  },
  {
    path: 'create-remitter',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./remitter/create-remitter/create-remitter.component').then(
        (mod) => mod.CreateRemitterComponent
      ),
  },
  {
    path: 'remitter-list',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./remitter/remitter-list/remitter-list.component').then(
        (mod) => mod.RemitterListComponent
      ),
  },
  {
    path: 'remitter-details/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./remitter/remitter-details/remitter-details.component').then(
        (mod) => mod.RemitterDetailsComponent
      ),
  },
  {
    path: 'uploaded-additional-file-list/:remitter_additional_file_request_id',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './remitter/uploaded-additional-file-list/uploaded-additional-file-list.component'
      ).then((mod) => mod.UploadedAdditionalFileListComponent),
  },
  {
    path: 'kyc-submissions-list/:remitter_id',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './remitter/kyc-submissions-list/kyc-submissions-list.component'
      ).then((mod) => mod.KycSubmissionsListComponent),
  },
  {
    path: 'exchange-rate-distinct-list',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './exchange-rate/exchange-rate-distinct-list/exchange-rate-distinct-list.component'
      ).then((mod) => mod.ExchangeRateDistinctListComponent),
  },
  {
    path: 'exchange-rate-list/:to_currency_id',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './exchange-rate/exchange-rate-list/exchange-rate-list.component'
      ).then((mod) => mod.ExchangeRateListComponent),
  },
  {
    path: 'exchange-rate-details/:id/:to_currency_id',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './exchange-rate/exchange-rate-details/exchange-rate-details.component'
      ).then((mod) => mod.ExchangeRateDetailsComponent),
  },
  {
    path: 'create-exchange-rate',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './exchange-rate/create-exchange-rate/create-exchange-rate.component'
      ).then((mod) => mod.CreateExchangeRateComponent),
  },
  {
    path: 'service-list',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./service/service-list/service-list.component').then(
        (mod) => mod.ServiceListComponent
      ),
  },
  {
    path: 'subservice-list/:parent_id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./service/subservice-list/subservice-list.component').then(
        (mod) => mod.SubserviceListComponent
      ),
  },
  {
    path: 'service-details/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./service/service-details/service-details.component').then(
        (mod) => mod.ServiceDetailsComponent
      ),
  },
  {
    path: 'create-service',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./service/create-service/create-service.component').then(
        (mod) => mod.CreateServiceComponent
      ),
  },
  {
    path: 'currency-list',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./currency/currency-list/currency-list.component').then(
        (mod) => mod.CurrencyListComponent
      ),
  },
  {
    path: 'create-currency',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./currency/create-currency/create-currency.component').then(
        (mod) => mod.CreateCurrencyComponent
      ),
  },
  { path: 'currency-details/:id',
    canActivate: [authGuard],
  loadComponent:() =>
    import('./currency/currency-details/currency-details.component').then(
      mod => mod.CurrencyDetailsComponent
    ),
  },
  {
    path: 'audit-list',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./audit/audit-list/audit-list.component').then(
        (mod) => mod.AuditListComponent
      ),
  },
  {
    path: 'content-management',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./cms/cms-listing/cms-listing.component').then(
        (mod) => mod.CmsListingComponent
      ),
  },
  // {
  //   path: 'create-content',
  //   loadComponent: () =>
  //     import('./cms/create-cms/create-cms.component').then(
  //       (mod) => mod.CreateCmsComponent
  //     ),
  // },
  {
    path: 'content-details/:slug',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./cms/update-cms/update-cms.component').then(
        (mod) => mod.UpdateCmsComponent
      ),
  },
  {
    path: 'faq',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./faq/faq-listing/faq-listing.component').then(
        (mod) => mod.FaqListingComponent
      ),
  },
  {
    path: 'create-faq',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./faq/create-faq/create-faq.component').then(
        (mod) => mod.CreateFaqComponent
      ),
  },
  {
    path: 'faq-details/:order',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./faq/update-faq/update-faq.component').then(
        (mod) => mod.UpdateFaqComponent
      ),
  },
  {
    path: 'slider',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./slider/slider-listing/slider-listing.component').then(
        (mod) => mod.SliderListingComponent
      ),
  },
  {
    path: 'create-slider',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./slider/create-slider/create-slider.component').then(
        (mod) => mod.CreateSliderComponent
      ),
  },
  {
    path: 'slider-details/:order',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./slider/update-slider/update-slider.component').then(
        (mod) => mod.UpdateSliderComponent
      ),
  },
  {
    path: 'voucher',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./voucher/voucher-listing/voucher-listing.component').then(
        (mod) => mod.VoucherListingComponent
      ),
  },
  {
    path: 'voucher-distribution/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './voucher/voucher-distribution-listing/voucher-distribution-listing.component'
      ).then((mod) => mod.VoucherDistributionListingComponent),
  },
  {
    path: 'create-voucher',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./voucher/create-voucher/create-voucher.component').then(
        (mod) => mod.CreateVoucherComponent
      ),
  },
  {
    path: 'create-transaction',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './transaction/create-transaction/create-transaction.component'
      ).then((mod) => mod.CreateTransactionComponent),
  },
  {
    path: 'transaction-details/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './transaction/transaction-details/transaction-details.component'
      ).then((mod) => mod.TransactionDetailsComponent),
  },
  {
    path: 'transaction-list',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./transaction/transaction-list/transaction-list.component').then(
        (mod) => mod.TransactionListComponent
      ),
  },
  {
    path: 'voucher-details/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./voucher/update-voucher/update-voucher.component').then(
        (mod) => mod.UpdateVoucherComponent
      ),
  },
  {
    path: 'announcement',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './announcement/announcement-listing/announcement-listing.component'
      ).then((mod) => mod.AnnoucementListingComponent),
  },
  {
    path: 'create-announcement',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './announcement/create-announcement/create-announcement.component'
      ).then((mod) => mod.CreateAnnoucementComponent),
  },
  {
    path: 'announcement-details/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        './announcement/update-announcement/update-announcement.component'
      ).then((mod) => mod.UpdateAnnoucementComponent),
  },
];
